document.querySelectorAll(".header").forEach(function (header) {
  header.addEventListener("click", function () {
    // Check if the clicked .header is already active
    const isActive = this.classList.contains("active");

    // Remove 'active' class from all .header and .gr-mn-atc elements
    document.querySelectorAll(".header").forEach(function (h) {
      h.classList.remove("active");
    });
    document.querySelectorAll(".gr-mn-atc .size-gr").forEach(function (atc) {
      atc.classList.remove("active");
    });
    document.querySelectorAll(".gr-mn-atc").forEach(function (atc) {
      atc.classList.remove("active");
    });
    // If the clicked .header was already active, stop here (toggle off)
    if (isActive) {
      return;
    }

    // Find the closest .swatch parent of the clicked .header
    const swatchParent = this.closest(".swatch");

    if (swatchParent) {
      // Find the .gr-mn-atc within the .swatch parent and add 'active' class
      const grMnAtc = swatchParent.querySelector(".gr-mn-atc .size-gr");
      if (grMnAtc) {
        grMnAtc.classList.add("active");
      }
      const grMnAtcactve = swatchParent.querySelector(".gr-mn-atc");
      if (grMnAtcactve) {
        grMnAtcactve.classList.add("active");
      }
    }

    // Add the 'active' class to the clicked .header
    this.classList.add("active");
  });
});
// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(function(){
//     const addToCartButtons = document.querySelectorAll('.boost-pfs-addtocart-select-options');

//     addToCartButtons.forEach(function(button) {
//         button.addEventListener('click', function() {
//             const form = this.closest('form');
//             if (form) {
//                 const url = form.getAttribute('data-href');
//                 if (url) {
//                     window.location.href = url;
//                 } else {
//                     console.error('data-href attribute is missing on the form element.');
//                 }
//             } else {
//                 console.error('Form element not found.');
//             }
//         });
//     });
//     },2000)
// });
